/* eslint-disable no-use-before-define */
import React from 'react'
import './market-check/market-check.css'
import { publish, mediaQueries, bufferedFn} from '../twd/twd'
import { Loader } from './market-check/loader'


export const MarketCheck = ({
    askId,
    askPrice,
    askQuantity,
    highYieldInd,
    holdCusip,
    holdInvType,
    marketCheck,
    askOwn,
}) => {

    let icon, label
    switch(marketCheck) {
        case 'P':
        case 'p':
            icon = iconAligned
            label= 'Aligned'
            break
        case 'F':
        case 'f':
            icon = iconHigher
            label = 'Higher'
            break
        case 'I':
        case 'i':
            icon = iconIssuficientData;
            label='Insufficient data'; break
        case 'Z':
        case 'z':
            icon = askOwn==='Y' ? iconHigher : '';
            label = askOwn==='Y' ? 'Higher' : '';
            break
        default:
            icon = ''
    }

    return <React.Fragment>
        <span
            style={{
                display:'inline-block',
                whiteSpace: 'nowrap'
            }}
            data-cusip={holdCusip}

            onMouseOver={(event) => {
                event.persist()
                showMarketcheck(event, askId, askPrice, askQuantity, highYieldInd, holdCusip, holdInvType)

            }}
        >
        {icon && <div style={iconStyle}>{icon}</div>}
        {label && <div style={labelStyle}>{label}</div>}
        </span>
    </React.Fragment>

}

const showMarketcheck = bufferedFn((event, askId, askPrice, askQuantity, highYieldInd, holdCusip, holdInvType) => {
    publish('show_flyout', {
        el:event.target,
        showIcon: false,
        html: <Loader {...{askId, askPrice, askQuantity, highYieldInd, holdCusip, holdInvType}} />,
        contentStyle:{maxWidth:'600px', width:'597px'},
        popperStyles:{
            maxWidth:`${Math.min(mediaQueries.width()-40, 600)}px`,
        }
    })
}, 100)


const iconAligned = <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="5" fill="#63AD02"/>
    </svg>
const iconHigher = <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0L13.0622 10.5H0.937822L7 0Z" fill="#D28720"/>
    </svg>
const iconIssuficientData = <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="4.5" fill="white" stroke="black"/>
    </svg>

const iconStyle = {
    display: 'inline-block',
    paddingRight: '5px',
    verticalAlign: 'top',
}

const labelStyle = {
    display: 'inline-block',
    maxWidth: '75px',
    whiteSpace: 'normal'
}



// WEBPACK FOOTER //
// ./src/offerings/market-check.js